'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import * as LucideIcons from 'lucide-react'
import { getItemsByGroup } from '@/config/adminNav'
import { resolveActiveNavId } from './adminShellHelpers'

// Desktop >= 1024px: full sidebar with label + icon
// Tablet 768-1023px: icon-only (compact mode, label visible on hover tooltip)
// Mobile < 768px: NOT rendered (AdminTabBar handles nav)
//
// The compact vs full decision is made purely by CSS media queries — we render
// both label and icon, CSS hides label below 1024px.
export default function AdminSidebar() {
  const pathname = usePathname()
  const activeId = resolveActiveNavId(pathname)
  const groups = getItemsByGroup()

  return (
    <aside className="admin-sidebar" aria-label="後台導覽">
      <nav>
        {groups.map(group => (
          <div key={group.groupId} className="admin-sidebar__group">
            <p className="admin-sidebar__group-label">{group.label}</p>
            <ul className="admin-sidebar__list">
              {group.items.map(item => {
                const Icon = LucideIcons[item.icon] || LucideIcons.Circle
                const isActive = item.id === activeId
                return (
                  <li key={item.id}>
                    <Link
                      href={item.href}
                      className={`admin-sidebar__item ${isActive ? 'is-active' : ''}`}
                      aria-current={isActive ? 'page' : undefined}
                      title={item.label}
                      data-tour={item.tourId || undefined}
                    >
                      <Icon size={18} aria-hidden="true" className="admin-sidebar__icon" />
                      <span className="admin-sidebar__label">{item.label}</span>
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  )
}
